"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IVocabRegistry.js.map